<icon-triggered-context-menu
    *ngIf="hasMenu"
    [menuItemsFactory]="menuItemsFactory">
</icon-triggered-context-menu>
